// CERSAI PAN WITH MOBILE-NO FLOW

import React, { useEffect, useState } from "react";
import Tab from "../../Components/kyc-components/Tab";
import BannerImage from "../../Components/login-components/banner-image/BannerImage";
import BottomCard from "../../Components/login-components/bottom-card/BottomCard";
import LogoContainer from "../../Components/login-components/logo-container/LogoContainer";
import PanCardFrame1 from "./Frames/PanCardFrame1";
import styles from "./KYCHomeScreen.module.css";
import { useSelector } from "react-redux";
import AadhaarCardFrame from "./Frames/AadhaarCardFrame/AadhaarCardFrame";
import OtherDocsFrame from "./Frames/OtherDocsFrame";
import MsHome from "../../Components/Maruti-Suzuki-components/MsHome";
import HiddenWrapper from "../../Components/global-components/hiddenWrapper/HiddenWrapper";
import InfoIcon from "@mui/icons-material/Info";
import {CommonTemplate} from "../../Components/global-components/CommonModal";
import Digitalformsixty from "./Frames/Digitalformsixty";
import { useNavigate } from "react-router-dom";

import Loader1 from "../../Components/loader-component/loader1"
import CommonButton from "../../Components/global-components/CommonButton/CommonButton";
import AnnouncementIcon from "../../Components/global-components/CommonIcons/AnnouncementIcon";
import { getAnnouncementMsg } from "../../services/announcement-msg";
import Marquee from "react-fast-marquee";

// import { userLocation } from "../Redux/userData";

const KYCHomeScreen = () => {
  const navigate = useNavigate();

  // Create an AbortController instance
const controller = new AbortController();
// Obtain a reference to the AbortSignal
const signal = controller.signal;

const [controllerState , setControllerState] = useState(null)

const [cersaiLoader ,setCersaiLoader] = useState(false)

  const activeTabs = useSelector((state) => state.Tabs.activeTab);
  const activeSwitch = useSelector((state) => state.switchButton.activeSwitch);
  const { digitalForm60Id }=useSelector((state)=>state.digitalFormSixty.formSixtyData);
  const userDetails = useSelector((state) => state.userDetails.userData);
  const disableTab = useSelector((state) => state.Tabs.disableTab);
  console.log("disable proprs",disableTab)
  const [isModalOpen, setIsModalOpen] = useState(true);
  // useEffect(() => {
  //   if (activeTabs === "pan") setIsModalOpen(true);
  // }, [activeTabs]);
console.log("rerotur",userDetails.phoneNumber && (userDetails.totalKyc >= userDetails.limit))
useEffect(()=>{
  if (userDetails.phoneNumber && (userDetails.totalKyc >= userDetails.limit)) {
    console.log("inside")
     navigate("/home");
  }
},[])

useEffect(() => {
  // disable browser button
  return () => {
    setTimeout(() => {
      window.history.forward();
    }, 0);
  };
}, []);

const [msg, setMsg] = useState([]);
useEffect(() => {
  getAnnouncementMsg().then((data) => {
    setMsg(data);
  });
}, []);

  return (
    <>
      {cersaiLoader ? (
        <Loader1 setCersaiLoader={setCersaiLoader} 
        controllerState={controllerState}
        />
      ) : (
        <div className={styles["kycHome_container"]}>
                 {activeTabs === "pan" && (
        <CommonTemplate
        isTemplateOpen={isModalOpen}
        closeTemplate={() => setIsModalOpen(false)}
      >
        <div className="flex flex-col items-center justify-center gap-y-3">
          <img
            src="/assets/bell.svg"
            alt="Alert"
            className="w-[60px] h-[60px]"
          />
          <div className="flex flex-row items-center gap-2  ">
            <img
              src="/assets/alert-yellow-dk.svg"
              alt="MS-logo"
              className="w-[30px] h-[30px]"
            />{" "}
            <h2 class="text-xl text-left font-black">
              CERSAI CKYC Update
            </h2>
          </div>

          <div className="flex flex-col justify-center px-6 py-2 gap-y-2 content_overflow">
            <p className="text-[0.80rem] font-medium text-left overflow_scroll">
            To complete your KYC, an OTP will now be sent to your mobile number registered with CERSAI.
            </p>
            <p className="text-[0.80rem] font-medium text-left ">
              <b> What this means for you: </b>
              <ul>
                <li>
                  {" "}
                  1. Your mobile number must be registered in the CERSAI records.{" "}
                </li>
                <li>
                  {" "}
                  2. When accessing CKYC information, you will receive an OTP on your registered number for verification.{" "}
                </li>
                <li>
                  {" "}
                  3. Date of Birth (DOB) will no longer be required to fetch CKYC details.{" "}
                </li>
              </ul>
            </p>
             <p className="text-[0.80rem] font-medium text-left">
             This change has been made as per CERSAI guidelines and is effective from 20th May.
             </p>
             <p className="text-[0.80rem] font-medium text-left">
             Please note: If this doesn’t work for you, no worries, you can still complete your KYC using Aadhaar or OVD journey.
             </p>
          </div>
          <div className=" m-auto w-[40%] ">
            <CommonButton
              center
              label="Understood"
              filled
              onClickHandler={() => setIsModalOpen(false)}
            />
          </div>
          {/* {msg[0] && msg[0]?.data && msg[0].data[0]?.message && <Marquee
            scrollamount="10"
            className="absolute bottom-0 right-0 text-[0.70rem] mb-2 text-gray-600"
          >
            <div className="flex items-center">
              {msg[0]?.data?.map((anMsg) => {
                return (
                  <>
                    <AnnouncementIcon />
                    &emsp;
                    <b className="text-red-500">{anMsg?.prefix}:</b>&emsp;
                    {anMsg?.message}&emsp;
                  </>
                );
              })}
            </div>
          </Marquee>} */}
        </div>
      </CommonTemplate>
      )}
          <BannerImage>
            <LogoContainer />
          </BannerImage>
          <MsHome>
            <div className="bg-secondaryH md:h-[100%] md:overflow-hidden">
              <BottomCard>
                <>
                  <div className="md:flex-[0_0_auto]">
                    <label className="md:text-lg md:hidden sm:block">
                      <b>KYC Document</b>
                    </label>
                    <p className="text-sm md:hidden sm:block">
                      Let's fetch your kyc details using
                    </p>
                    <div className={"mb-3 md:hidden sm:block"}></div>
                    {!digitalForm60Id ? (
                      <div>
                        <Tab isDisabledTab={disableTab} />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="md:flex-[1_0_0] md:overflow-hidden">
                    {activeTabs === "pan" && (
                      <div className="h-full w-full md:flex md:flex-col ">
                        <PanCardFrame1 setCersaiLoader={setCersaiLoader}
                        setControllerState={setControllerState}
                        controller={controller}
                        signal={signal}

                        />
                      </div>
                    )}

                    {activeTabs === "aadhaar" && (
                      <div className="w-full h-full  md:flex md:flex-col ">
                        <AadhaarCardFrame />
                      </div>
                    )}
                    {activeTabs === "otherDocs" && (
                      <div className="w-full h-full   md:flex md:flex-col ">
                        <OtherDocsFrame />
                      </div>
                    )}
                  </div>
                </>
              </BottomCard>
            </div>
          </MsHome>
        </div>
      )}
    </>
  );
};

export default KYCHomeScreen;





